import { ProductInventoryTabs } from "../productinventory.constants";

export const getCurrentTabParams = (currentTab) => {
  switch (currentTab) {
    case ProductInventoryTabs.lowInventory:
      return {
        'low-inventory': true
      };

    case ProductInventoryTabs.outofStock:
      return {
        'out-of-stock': true
      };

      case ProductInventoryTabs.allProducts:
        return {
          'all-products': true
        };
        
    default:
      return {};
  }
}